var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYesTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189.638,
    height: 113.364,
    viewBox: "0 0 189.638 113.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 113.426,
    height: 113.364,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 26.198,
    height: 26.192,
    fill: "#d0fb56",
    stroke: "#0c2247",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(-867.561 -423.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(903.759 423.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M0,49.3c.182,1.154.365,2.307.5,3.186.849-15.5,7.573-28.433,19.367-38.68A54.369,54.369,0,0,1,61.218.2a56.5,56.5,0,0,1,52.2,57.293c-.5,32.057-26.719,54.341-52.512,55.32l2.5.549H49.218l2.848-.355A54.838,54.838,0,0,1,16.591,96.364C6.852,86.468,1.127,74.666.63,60.6c-.213,1.349-.421,2.675-.63,4V49.3m56.839,59.629c29.428.214,51.9-24.107,52.345-51.5C109.643,29.27,86.815,4.669,57.575,4.235A52.616,52.616,0,0,0,4.353,56.025c-.3,28.608,22.856,53.165,52.485,52.906",
    transform: "translate(0 0)",
    fill: "#03234a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M57.357,109.435c-29.629.259-52.783-24.3-52.485-52.906A52.617,52.617,0,0,1,58.093,4.739c29.24.433,52.068,25.036,51.609,53.191-.447,27.4-22.917,51.719-52.345,51.5m-6.908-37.77c-.363-.277-.6-.449-.826-.631Q40.281,63.562,30.932,56.1c-1.534-1.221-2.681-1.265-3.527-.275-.887,1.04-.625,2.23.928,3.487q10.124,8.181,20.3,16.3c1.787,1.426,2.8,1.3,4.359-.449q15.037-16.875,30.05-33.772c1.373-1.546,2.766-3.078,4.052-4.695a1.963,1.963,0,0,0-.142-2.884,2.114,2.114,0,0,0-2.91.153c-.729.674-1.372,1.443-2.033,2.187Q67.315,52.668,52.629,69.19c-.707.8-1.406,1.6-2.18,2.475",
    transform: "translate(-0.518 -0.504)",
    fill: "#d0fb56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M53.075,75.069c.774-.878,1.473-1.68,2.18-2.475q14.687-16.522,29.376-33.04c.661-.744,1.3-1.514,2.033-2.187a2.114,2.114,0,0,1,2.91-.153,1.963,1.963,0,0,1,.142,2.884c-1.286,1.616-2.679,3.149-4.052,4.695Q70.646,61.686,55.614,78.566c-1.558,1.748-2.572,1.876-4.359.449q-10.177-8.115-20.3-16.3c-1.554-1.256-1.816-2.446-.928-3.487.845-.99,1.993-.945,3.527.275q9.363,7.447,18.692,14.937c.228.181.463.354.826.631",
    transform: "translate(-3.144 -3.908)",
    fill: "#03234a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(867.561 423.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M0,13.047c.548-.109,1.1-.212,1.644-.327A29.036,29.036,0,0,0,6.66,11.3a8.131,8.131,0,0,0,4.65-4.659A34.8,34.8,0,0,0,13,.244a2.084,2.084,0,0,1,.049-.2c.005-.018.034-.028.049-.04.276,1.246.535,2.5.833,3.738a17.171,17.171,0,0,0,1.311,3.716,7.9,7.9,0,0,0,4.154,3.8,31.04,31.04,0,0,0,6.219,1.683c.162.032.323.062.484.1.02,0,.035.028.1.08-.667.135-1.3.256-1.929.391a28.451,28.451,0,0,0-4.708,1.343,8.16,8.16,0,0,0-4.72,4.728A33.907,33.907,0,0,0,13.218,25.7a1.586,1.586,0,0,1-.159.494c-.088-.439-.173-.879-.264-1.317a30.485,30.485,0,0,0-1.488-5.361A8.126,8.126,0,0,0,6.652,14.86,33.358,33.358,0,0,0,.494,13.216L.01,13.122,0,13.047",
    fill: "#d0fb56",
    stroke: "#0c2247",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(1031 510.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16-2",
    "data-name": "Group 16",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112-2",
    "data-name": "Path 112",
    d: "M0,13.047c.548-.109,1.1-.212,1.644-.327A29.036,29.036,0,0,0,6.66,11.3a8.131,8.131,0,0,0,4.65-4.659A34.8,34.8,0,0,0,13,.244a2.084,2.084,0,0,1,.049-.2c.005-.018.034-.028.049-.04.276,1.246.535,2.5.833,3.738a17.171,17.171,0,0,0,1.311,3.716,7.9,7.9,0,0,0,4.154,3.8,31.04,31.04,0,0,0,6.219,1.683c.162.032.323.062.484.1.02,0,.035.028.1.08-.667.135-1.3.256-1.929.391a28.451,28.451,0,0,0-4.708,1.343,8.16,8.16,0,0,0-4.72,4.728A33.907,33.907,0,0,0,13.218,25.7a1.586,1.586,0,0,1-.159.494c-.088-.439-.173-.879-.264-1.317a30.485,30.485,0,0,0-1.488-5.361A8.126,8.126,0,0,0,6.652,14.86,33.358,33.358,0,0,0,.494,13.216L.01,13.122,0,13.047",
    fill: "#d0fb56",
    stroke: "#0c2247",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    transform: "translate(888 510)",
    fill: "#d0fb56",
    stroke: "#0c2247",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    transform: "translate(1027 449)",
    fill: "#d0fb56",
    stroke: "#0c2247",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesTick);
export default __webpack_public_path__ + "static/media/YesTick.16bacd6921d8b772212749a415e0c04c.svg";
export { ForwardRef as ReactComponent };